module.exports = __webpack_public_path__ + "img/address-2.26fe7857.png";